import { Shield } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Badge } from '@/shared/ui/badge';
import { UserRole } from '@cargovibe/shared-types';

interface RoleBadgeProps {
  role: UserRole;
}

export function RoleBadge({ role }: RoleBadgeProps): React.JSX.Element {
  const { t } = useTranslation();

  if (role === UserRole.CompanyAdmin) {
    return (
      <Badge variant="default" className="gap-1">
        <Shield size={12} />
        {t('users.roles.company_admin')}
      </Badge>
    );
  }

  if (role === UserRole.Admin) {
    return (
      <Badge variant="default" className="gap-1">
        <Shield size={12} />
        {t('users.roles.admin')}
      </Badge>
    );
  }

  return <Badge variant="secondary">{t('users.roles.driver')}</Badge>;
}
